import { IAdpVoucherHolder } from "./adp-voucher-holder";
export interface IAdpVoucherHolderCheckMissingPdfResponse {
    data: {
        success: boolean;
        message: string;
        results: {
            notFounds: IAdpVoucherHolder[],
            founds: IAdpVoucherHolder[]
        }
    }
}